<div class="mat-calendar-header limited-years-calendar-header">
  <div class="limited-years-calendar-header__modes" role="group" [attr.aria-label]="navLabel('DatepickerNavGroupAria', 'Navegação do calendário')">
    <button
      type="button"
      mat-stroked-button
      class="limited-years-calendar-header__mode-btn"
      [class.limited-years-calendar-header__mode-btn--active]="calendar.currentView === 'multi-year'"
      (click)="setView('multi-year')"
    >
      {{ navLabel("DatepickerNavYears", "Anos") }}
    </button>
    <button
      type="button"
      mat-stroked-button
      class="limited-years-calendar-header__mode-btn"
      [class.limited-years-calendar-header__mode-btn--active]="calendar.currentView === 'year'"
      (click)="setView('year')"
    >
      {{ navLabel("DatepickerNavMonths", "Meses") }}
    </button>
    <button
      type="button"
      mat-stroked-button
      class="limited-years-calendar-header__mode-btn"
      [class.limited-years-calendar-header__mode-btn--active]="calendar.currentView === 'month'"
      (click)="setView('month')"
    >
      {{ navLabel("DatepickerNavDays", "Dias") }}
    </button>
  </div>

  <div class="limited-years-calendar-header__period-row">
    <div class="limited-years-calendar-header__period-inner">
      <p class="limited-years-calendar-header__summary">
        {{ periodButtonText }}
      </p>
      <div class="limited-years-calendar-header__arrows" *ngIf="showPeriodNavArrows()">
        <button
          mat-icon-button
          type="button"
          class="mat-calendar-previous-button"
          [disabled]="!previousEnabled()"
          (click)="previousClicked()"
          [attr.aria-label]="prevButtonLabel"
        ></button>
        <button
          mat-icon-button
          type="button"
          class="mat-calendar-next-button"
          [disabled]="!nextEnabled()"
          (click)="nextClicked()"
          [attr.aria-label]="nextButtonLabel"
        ></button>
      </div>
    </div>
  </div>
</div>
